export enum UseTypeCategories {
	OTHER = 'OTHER',
	HEALTHCARE_TRAINING = 'HEALTHCARE_TRAINING',
	LANGUAGE = 'LANGUAGE',
	COMMUNICATION = 'COMMUNICATION',
	TEACHER_TRAINING = 'TEACHER_TRAINING'
}
